import { useUserInfoQuery } from "../hooks/api/useUserInfo";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeCustomers } from "../reducer/customersSlice";

export default function useCheckLogin() {
    const getUserInfo = useUserInfoQuery();
    const dispatch = useDispatch();

    useEffect(() => {
        if (getUserInfo.data) {
            // 서버에서 JWT 디코딩된 customers 데이터를 Redux store에 저장
            dispatch(changeCustomers({
                value: getUserInfo.data
            }));
        }

        if (getUserInfo.error) {
            // 인증 실패 시 로그인 페이지로 이동
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
    }, [getUserInfo.data, getUserInfo.error]);

    // customers 정보 받아오기 성공하면 화면 노출
    if (getUserInfo.data) {
        return true;
    }
}